<template>
    <div id="contenedor-nueva-auditoria">
        <v-form v-model="formularioValido" ref="registraNuevaAuditoria">
          <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Registrar nueva Auditoría
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
              <v-row no-gutters>
                <v-col
                  cols="12"
                  md="3">
                  <ejercicio-picker
                  v-model="auditoria.ejercicio">
                  </ejercicio-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="9">
                  <custom-autocomplete
                    v-model="auditoria.idEnteFiscalizador"
                    label="Ente Fiscalizador"
                    :items="getEntesFiscalizadores"
                    item-text="descripcion"
                    item-value="id"
                    clearable
                    class="pt-0"
                    :rules="[mixReglas.requerido]"
                    >
                </custom-autocomplete>
                </v-col>
              </v-row>
              <custom-text-area
                cols="12"
                v-model="auditoria.nombre"
                label="Nombre"
                rows="3"
                :rules="[mixReglas.requerido]">
              </custom-text-area>
              <v-row no-gutters>
                <v-col
                  cols="12"
                  md="6">
                  <custom-date-picker
                  v-model="auditoria.periodoDel"
                  label="Del"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
                </v-col>
                <v-col
                  cols="12"
                  md="6">
                  <custom-date-picker
                  v-model="auditoria.periodoAl"
                  label="Al"
                  :rules="[mixReglas.requerido]"
                  @input="validaFechas">
                </custom-date-picker>
                </v-col>
              </v-row>
              <v-card class="selected ma-4 pa-4" flat>
              <v-row align="center" justify="center">
                <v-file-input
                v-show="false"
                show-size
                label="Seleccionar Archivo PDF"
                type="file"
                ref="anexoDocumento"
                name="anexo"
                id="anexo"
                accept=".pdf"
                @change="seleccion"
                >
                </v-file-input>
                <v-btn text large icon class="secondary--text" @click="seleccionarArchivo">
                    <v-icon center>
                      mdi-paperclip
                    </v-icon>
                </v-btn>
                <template v-if="nombreArchivoSeleccionado">
                  <span class="text-caption font-weight-light secondary--text ">
                    {{ nombreArchivoSeleccionado }}</span>
                </template>
                <template v-else>
                  <span class="text-caption font-weight-light secondary--text">
                     ... </span>
                </template>
              </v-row>
              <v-row align="center" justify="center">
              <custom-button
                  class="mx-4 text-caption font-weight-light"
                  tipo="formCancelar"
                  :label="rutaArchivo ? 'Cambiar' : 'Seleccionar Archivo'"
                  @click="seleccionarArchivo">
                </custom-button>
              </v-row>
              </v-card>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
          </v-card>
        </v-form>
    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import mixAuditorias from './mixAuditorias';

export default {
  name: 'NuevaAuditoria',
  mixins: [mixAuditorias],
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      rutaArchivo: null,
      nombreArchivoSeleccionado: null,
      archivoAnexo: null,
      auditoria: {
        idEnteFiscalizador: null,
        nombre: null,
        ejercicio: new Date().getFullYear(),
        periodoDel: new Date().toISOString().substr(0, 10),
        periodoAl: '',
        fileData: null,
      },
      documento: {
        path: '',
        nombre: '',
      },
    };
  },
  components: {
    CustomAutocomplete,
    CustomButton,
    CustomDatePicker,
    CustomTextArea,
    EjercicioPicker,
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registraNuevaAuditoria.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    seleccion() {
      if (document.getElementById('anexo').files.length === 1) {
        this.rutaArchivo = URL.createObjectURL(
          document.getElementById('anexo').files[0],
        );
        this.nombreArchivoSeleccionado = document.getElementById('anexo').files[0].name;
      }
    },
    seleccionarArchivo() {
      document.getElementById('anexo').click();
    },
    async guardar() {
      this.enviandoFormulario = true;
      const datosArchivo = this.setDatosArchivo();

      if (this.rutaArchivo !== null) {
        const archivo = await this.mixSubirArchivo(datosArchivo);
        if (archivo.status === 'ok') {
          this.auditoria.fileData = JSON.stringify(archivo.data);
        }
      }
      await this.mixAgregarAuditoria();
    },
    setDatosArchivo() {
      const datos = {
        // nombre: `${this.nombreArchivoSeleccionado}`,
        nombre: 'auditoria',
        path: 'Auditorias/',
      };
      return datos;
    },
    validaFechas() {
      if (new Date(this.auditoria.periodoDel) > new Date(this.auditoria.periodoAl)) {
        this.auditoria.periodoAl = '';
      }
    },
  },
};
</script>
